(() => {
  const inject = [
    '$sce',
    '$timeout',
  ];

  angular
    .module('app.components')
    .directive('campaignIntegratedType', [...inject, (
      $sce,
      $timeout,
    ) => ({
      restrict: 'A',
      replace: true,
      transclude: true,
      scope: {
        campaign: '=',
      },
      controller: ['$scope', ($scope) => {
        if (!$scope.campaign) {
          return false;
        }

        $scope.isIntegrated = $scope.campaign.type == 'integrated';
        $scope.active = false;
        $scope.fadeout = false;
        $scope.onMouseOver = () => {
          $scope.active = true;
          $scope.fadeout = false;
        };
        $scope.onMouseLeave = () => {
          $scope.fadeout = true;
          $scope.active = false;
        };

        $scope.sources = $scope.campaign.sources;
        $scope.getProvider = ({ provider }) => {
          const sources = {
            audiencereport: 'AudienceReport',
            facebook: 'Facebook',
            youtube: 'Youtube',
            adwords: 'Youtube',
            dv360: 'Youtube',
          };
          return sources[provider];
        };
      }],
      templateUrl: $sce.trustAsResourceUrl(`/assets/js/app/components/tooltip/campaignIntegratedType.html?v=${window.BUILD_VERSION}`)
    })
  ]);
})();
